import $http from '@/module/http';

const categoryModel = [
  {
    name: 'CPU',
    key: 'cpu',
    hardware_key: 'cpu_model__option_value',
    model: []
  },
  {
    name: 'Memory',
    key: null,
    hardware_key: 'memory_size',
    model: [
      { option_label: '8.00' },
      { option_label: '12.00' },
      { option_label: '16.00' },
      { option_label: '24.00' },
      { option_label: '31.99' },
      { option_label: '32.00' },
      { option_label: '36.00' },
      { option_label: '48.00' },
      { option_label: '64.00' },
      { option_label: '80.00' },
      { option_label: '96.00' },
      { option_label: '128.00' },
      { option_label: '144.00' },
      { option_label: '160.00' },
      { option_label: '192.00' },
      { option_label: '256.00' },
      { option_label: '288.00' },
      { option_label: '384.00' },
      { option_label: '512.00' },
      { option_label: '768.00' },
      { option_label: '1288.00' }
    ]
  },
  {
    name: 'Disk',
    key: null,
    hardware_key: 'disk_description__icontains',
    model: [
      { option_label: '120GB SSD' },
      { option_label: '240GB SSD' },
      { option_label: '256GB SSD' },
      { option_label: '512GB SSD' },
      { option_label: '960GB SSD' },
      { option_label: '1TB SSD' },
      { option_label: '2TB SSD' },
      { option_label: '4TB SSD' },

      { option_label: '500GB SATA' },
      { option_label: '750GB SATA' },
      { option_label: '1TB SATA' },
      { option_label: '2TB SATA' },
      { option_label: '3TB SATA' },
      { option_label: '4TB SATA' },
      { option_label: '5TB SATA' },
      { option_label: '6TB SATA' },
      { option_label: '8TB SATA' },
      { option_label: '10TB SATA' },
      { option_label: '12TB SATA' },
      { option_label: '16TB SATA' },
      { option_label: '18TB SATA' },

      { option_label: '960GB NVME' },
      { option_label: '1TB NVME' },
      { option_label: '1.92TB NVME' },
      { option_label: '2TB NVME' },
      { option_label: '4TB NVME' }
    ]
  },
  {
    name: 'GPU',
    key: 'baremetal_gpu_model',
    hardware_key: 'new_gpu_model__option_value',
    model: []
  },
  {
    name: 'Motherboard',
    key: 'baremetal_motherboard_model',
    hardware_key: 'motherboard_model__option_value',
    model: []
  },
  {
    name: 'Chassis',
    key: 'baremetal_chassis_model',
    hardware_key: 'chassis_model__option_value',
    model: []
  },
  {
    name: 'Others',
    key: null,
    model: []
  }
];
let cg = null;
export default {
  strict: true,
  namespaced: true,
  state: {
    category: []
  },
  mutations: {
    setCategory(state, category) {
      state.category = category;
    }
  },
  actions: {
    getUsageList: ({ commit }, force = false) => {
      if (!cg || force) {
        cg = $http
          .get(`system_options/`, {
            params: {
              page_size: 999,
              page: 1,
              q: `option_type__inner_name__in=baremetal_cpu_model|baremetal_chassis_model|baremetal_motherboard_model|baremetal_gpu_model`
            }
          })
          .then(({ results }) => {
            const model = categoryModel.map((item) => {
              return {
                ...item,
                model:
                  results.filter((m) => m.key === item.key).length > 0
                    ? results.filter((m) => m.key === item.key)
                    : item.model
              };
            });
            commit('setCategory', model);
            return Promise.resolve(model);
          });
        return cg;
      }
    }
  }
};
